import React from 'react';
import {
  MasonryEngineNode,
  MasonryEngineNodeRendererProps,
} from '@leagueplatform/masonry-engine';
import {
  useInvokeAction,
  MasonryDriverAction,
} from '@leagueplatform/masonry-renderers';
import { Box } from '@leagueplatform/genesis-core';
import { FeaturesHighlightView } from '../../../components/feature-highlight-view/features-highlight-view.component';
import { FeatureSlide } from '../../../types/features-highlight.type';

type OnboardingFlowMasonryViewNodeProperties = {
  heading: string;
  slides: FeatureSlide[];
  currentSlide?: number;
  isLoading?: boolean;
};

type OnboardingFlowMasonryViewNodeActions = {
  onNext?: MasonryDriverAction;
};

export const NODE_TYPE_ONBOARDING_FLOW_MASONRY_VIEW =
  'onboardingFlowMasonryView';

export type OnboardingFlowMasonryViewNode = MasonryEngineNode<
  typeof NODE_TYPE_ONBOARDING_FLOW_MASONRY_VIEW,
  OnboardingFlowMasonryViewNodeProperties,
  OnboardingFlowMasonryViewNodeActions
>;

export type OnboardingFlowMasonryViewRendererProps =
  MasonryEngineNodeRendererProps<OnboardingFlowMasonryViewNode>;

export const OnboardingFlowMasonryViewRenderer = ({
  heading,
  slides,
  currentSlide = 0,
  isLoading = false,
  onNext,
}: OnboardingFlowMasonryViewRendererProps) => {
  const invokeAction = useInvokeAction();

  const handleNext = React.useCallback(() => {
    if (onNext) {
      invokeAction({
        ...onNext,
      });
    }
  }, [invokeAction, onNext]);

  return (
    <Box css={{ width: '100vw', height: '100vh' }}>
      <FeaturesHighlightView
        heading={heading}
        slides={slides}
        currentSlide={currentSlide}
        isLoading={isLoading}
        handleNext={handleNext}
      />
    </Box>
  );
};
